
























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({

	emits:[],
	props:{
		translateKey:{
			type:String,
			default:""
		}
	},
	components:{
	},
	setup(){
		
		

		return {

		};
	}
});

